<template>
    <div >
        <div class="status-container">
            <div class="status-left" :class="{'status-left2': isTwoTask}">
            </div>
            <div class="status-icon"><img
              v-if="taskData.ladderNum !=-1"
              :class="{'just-get-the':(taskData.justGetThe || (taskData.isCompleteMission && !taskData.isReceiveReward) && taskData.ladderNum!=0)}"
             :src="getTaskStatusIcon" alt="" @click="handleUse"
             >
             </div>
            <div class="status-right" :class="{'status-right2': isTwoTask}">
                <!-- 使用定位定在右边 -->
                <TaskStatusLine 
                  v-if="taskData.index != getTaskListDataLength-1 && taskData.ladderNum !=-1"
                  :classIndex="classIndex"
                  :betweenNextFocusNode="taskData.betweenNextFocusNode"
                  :getTaskListDataLength="getTaskListDataLength"
                />
            </div>
        </div>
        <div class="desc-line" :class="{'current-task':currentLadderNum== taskData.ladderNum}">{{taskData.descFirstLine}}</div>
        <div class="desc-line" :class="{'current-task':currentLadderNum== taskData.ladderNum}">{{taskData.descSecondLine}}</div>
    </div>
</template>

<script>
import TaskStatusLine from './taskStatusLine.vue'
import NOCOMPLETEICON from '@/assets/images/oldCustomer/status1.png'
import NOREWORDICON from '@/assets/images/oldCustomer/status2.png'
import COMPLETEICON from '@/assets/images/oldCustomer/status3.png'
import TORECEIVE from '@/assets/images/oldCustomer/status4.gif'
import GETSUCCESS from '@/assets/images/oldCustomer/get_success.gif'

import NOCOMPLETEICON99 from '@/assets/images/oldCustomer/99_status1.png'
import NOREWORDICON99 from '@/assets/images/oldCustomer/99_status2.png'
import COMPLETEICON99 from '@/assets/images/oldCustomer/99_status3.png'
import TORECEIVE99 from '@/assets/images/oldCustomer/99_status4.gif'
import GETSUCCESS99 from '@/assets/images/oldCustomer/99_get_success.gif'

Object.freeze(NOCOMPLETEICON)
Object.freeze(NOREWORDICON)
Object.freeze(COMPLETEICON)
Object.freeze(NOCOMPLETEICON99)
Object.freeze(NOREWORDICON99)
Object.freeze(COMPLETEICON99)
Object.freeze(TORECEIVE)
Object.freeze(TORECEIVE99)
Object.freeze(GETSUCCESS)
Object.freeze(GETSUCCESS99)

export default {
  name: 'TaskStatus',
  props: {
    classIndex: {
      default: 0
    },
    taskData: {
      default: () => {}
    },
    currentLadderNum: {
      default: 0
    },
    getTaskListDataLength: {
      default: 0
    }
  },
  data () {
    return {
      TORECEIVE
    }
  },
  components: {
    TaskStatusLine
  },
  computed: {
    country () {
      return this.$store.state.country
    },
    isTwoTask () {
      return this.getTaskListDataLength == 2 // eslint-disable-line
    },
    // 有一个静态图导致有
    getTaskStatusIcon () {
      // isCompleteMission: false, // 是否完成当前子任务
      // isReceiveReward:false // 是否领取当前任务奖励
      // ladderNum为0为空置节点
      // 待完成
      // 待领取
      // 已领取
      if (this.taskData.justGetThe) { // 刚刚领取任务
        if (this.country === 'BR') {
          return GETSUCCESS99
        } else {
          return GETSUCCESS
        }
      } else if (this.taskData.ladderNum == 0) { //eslint-disable-line 
        if (this.country === 'BR') {
          return NOREWORDICON99
        } else {
          return NOREWORDICON
        }
      } if (!this.taskData.isCompleteMission) { // 待完成
        if (this.country === 'BR') {
          return NOCOMPLETEICON99
        } else {
          return NOCOMPLETEICON
        }
      } else if (this.taskData.isCompleteMission && !this.taskData.isReceiveReward) { // 待领取
        if (this.country === 'BR') {
          return TORECEIVE99
        } else {
          return TORECEIVE
        }
      } else if (this.taskData.isCompleteMission && this.taskData.isReceiveReward) {
        if (this.country === 'BR') { // 已领取
          return COMPLETEICON99
        } else {
          return COMPLETEICON
        }
      }
    }
  },
  methods: {
    handleUse () {
      this.$emit('currentTaskClick')
      if (this.taskData.isHasReward && this.taskData.isCompleteMission && !this.taskData.isReceiveReward && !this.taskData.justGetThe) {
        this.$emit('handleUse', {
          ladderNum: this.taskData.ladderNum,
          index: this.taskData.index
        })
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
@import "~@/common/stylus/variables"
.status-container
    display flex
    align-items center
    margin-bottom 14px
.status-icon
    position relative
    width 108px
    height 84px
    img
        width 84px
        height 84px
        margin 0 12px
    .just-get-the
        position relative
        left -21px
        top -21px
        width 126px
        height 126px
        margin 0 12px

.status-left,.status-right
    width 80px
    position relative
    top -6px

.status-left2, .status-right2
    width 119px

.desc-line
    text-align center
    height 24px
    font-family 'Aspira Light'
    font-size 24px
    color #000000
    font-weight 200
    padding 0 10px
    margin-bottom 6px
    overflow hidden
    white-space: nowrap; 
    text-overflow: ellipsis;
.current-task
    font-color()
    font-family 'Aspira Medium'
    font-weight 500
    font-size 26px
</style>